import { appType } from "@/main"
import VueScrollPicker from "vue-scroll-picker"
export default function useVueScrollPicker(app: appType) {
    app.use(VueScrollPicker)
}